export enum AccessibilityRole {
  ALERT = 'alert',
  BANNER = 'banner',
  BUTTON = 'button',
  CHECKBOX = 'checkbox',
  DIALOG = 'dialog',
  FOOTER = 'contentinfo',
  FORM = 'form',
  GROUP = 'group',
  HEADER = 'none',
  HEADING = 'heading',
  IMAGE = 'image',
  LINK = 'link',
  LIST = 'list',
  LISTITEM = 'listitem',
  MAIN = 'main',
  NAVIGATION = 'navigation',
  NONE = 'none',
  PROGRESSBAR = 'progressbar',
  RADIO = 'radio',
  RADIOGROUP = 'radiogroup',
  STATUS = 'status',
  SWITCH = 'switch',
  TAB = 'tab',
  TABLIST = 'tablist',
  TABPANEL = 'tabpanel',
  TEXT = 'text',
  TOOLTIP = 'tooltip',
}
